import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { getShippingPolicies } from 'vivino-js/api/merchants';
import { CartsContext } from 'vivino-js/context/CartsContext';
import { isZipBasedShipping } from 'vivino-js/helpers/countryHelpers';
import { getShippingZip } from 'vivino-js/helpers/shipToHelper';

import ShippingPolicyPresentational from './ShippingPolicy.presentational';

const ShippingPolicy = ({
  merchantId,
  quantity,
  totalAmount,
  shippingEstimate,
  countryCode,
  quantityHasChanged,
}) => {
  const { carts } = useContext(CartsContext);
  const [merchantShippingMessage, setMerchantShippingMessage] = useState('');
  const [shippingPolicy, setShippingPolicy] = useState();
  const [shippingZipCode, setShippingZipCode] = useState(getShippingZip());
  const [shippingZipChanged, setShippingZipChanged] = useState(false);
  const [drawerIsOpen, setDrawerIsOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const isZipRequired = isZipBasedShipping(countryCode);

  useEffect(() => {
    if (carts.length > 0) {
      const currentCart = carts.find((cart) => cart.merchant_id === merchantId);
      if (currentCart) {
        setMerchantShippingMessage(currentCart.shipping_message);
      }
    }
  }, [carts.length]);

  useEffect(() => {
    if (isZipRequired && !shippingZipCode) {
      return;
    }

    // @ts-ignore
    getShippingPolicies({
      merchantId,
      countryCode,
      zipCode: shippingZipCode,
      bottleQuantity: quantity,
      totalAmount: totalAmount,
    })
      .then((data) => {
        setShippingPolicy(data.shipping_policies[0]);
        setDrawerIsOpen(true);
        setErrorMessage(null);
      })
      .catch((err) => {
        setErrorMessage(err?.message);
      });
  }, [shippingZipCode, quantity, merchantId]);

  const handleZipValidated = (zipCode) => {
    setShippingZipCode(zipCode);
    setShippingZipChanged(true);
  };

  return (
    <ShippingPolicyPresentational
      quantityHasChanged={quantityHasChanged}
      merchantShippingMessage={merchantShippingMessage}
      shippingEstimate={shippingEstimate}
      countryCode={countryCode}
      shippingPolicy={shippingPolicy}
      onZipValidated={handleZipValidated}
      shippingZipChanged={shippingZipChanged}
      drawerIsOpen={drawerIsOpen}
      errorMessage={errorMessage}
      merchantId={merchantId}
      shippingZipCode={shippingZipCode}
    />
  );
};

ShippingPolicy.propTypes = {
  merchantId: PropTypes.number,
  totalAmount: PropTypes.number,
  quantity: PropTypes.number,
  quantityHasChanged: PropTypes.bool,
  merchantShippingMessage: PropTypes.string,
  countryCode: PropTypes.string,
  shippingEstimate: PropTypes.string,
};

export default ShippingPolicy;
